//summary of everything
import React, { useState, useEffect } from 'react';
import { Container, Alert, Table, Button } from 'react-bootstrap';
import { useNavigate, useParams, Link } from 'react-router-dom';
import axios from 'axios';
import {apiUrl, reportEndDateDiff, reportStartDateDiff} from '../../../util/Api';
import PRContent from '../components/PRContent';
//import { useSelector } from 'react-redux';
//import { getUserAccounts } from '../../app/slices/UserSlice';
//import {Helmet} from "react-helmet";

import { toFactDate, fromFactDate, toDisplayDate, alterDate, isFactDate, roundNum } from '../../../util/ChartUtils';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'

//import AnalyticsNav from '../../components/AnalyticsNav';
import LeftNav from '../../../components/LeftNav';

import GuardrailBtn from './components/GuardrailBtn';

const SENTIMENT_THRESHOLD = process.env.REACT_APP_SENTIMENT_THRESHOLD || 0.5;

const ResponseFlow = () => {
    const [errors, setErrors] = useState([]);
    //const [account, setAccount] = useState(null);
    const [app, setApp] = useState(null);
    const [response, setResponse] = useState(null);
    const [prompts, setPrompts] = useState([]);
    const [range, setRange] = useState(null);

    const [startDatePicker, setStartDatePicker] = useState(null);
    const [endDatePicker, setEndDatePicker] = useState(null);
    const [showPicker, setShowPicker] = useState(false);

    const [datesForLink, setDatesForLink] = useState('');

    let navigate = useNavigate();
    let { accountKey, appKey, responseId, startFactDate, endFactDate } = useParams();

    //const currUserAccounts = useSelector(getUserAccounts);
    //const currUserAccount = currUserAccounts.find(a => a.accountKey===accountKey);
    //const currRoleId = currUserAccount ? currUserAccount.roleId : 0;

    const onDateChange = (dates) => {
        const [start, end] = dates;
        //console.log('dates:', dates);
        setStartDatePicker(start);
        setEndDatePicker(end);
        //setShowPicker(false);
        if (end !== null) {
            //console.log('finished')
            setShowPicker(false);
            //window.location = '/account/' + accountKey + '/analytics/dashboard/' + appKey + '/' + toFactDate(start) + '/' + toFactDate(end);
            navigate(`/account/${accountKey}/analytics/app/${appKey}/responseflow/${toFactDate(start)}/${toFactDate(end)}`);
        }
    }

    useEffect(() => {

        
        let linkDates = "";
        if(startFactDate != null && startFactDate != ""){
            linkDates = `/${startFactDate}`;
            if(endFactDate != null && endFactDate != "") {
                linkDates += `/${endFactDate}`;
            }
            setDatesForLink(linkDates);
        }
        

        let startDate = new Date();
        let endDate = new Date();
        let startFact = startFactDate;
        let endFact = endFactDate;

        if (!isFactDate(endFact)) {
            //console.log('endFactDate is null')
            endDate.setDate(endDate.getDate() - reportEndDateDiff);
            endFact = toFactDate(endDate);
        } else {
            //console.log('endFactDate is not null', endFact)
            endDate = fromFactDate(endFact);
        }

        if (!isFactDate(startFact)) {
            //console.log('startFactDate is null')
            startDate.setDate(endDate.getDate() - reportStartDateDiff);
            startFact = toFactDate(startDate);
        } else {
            //console.log('startFactDate is not null', startFact)
            startDate = fromFactDate(startFact);
        }

        setRange({ startDate: startFact, endDate: endFact });

        document.title = "reconify analytics";

        //setStartDatePicker(startDate);
        //setEndDatePicker(endDate);

        let options = {
            accountKey: accountKey,
            appKey: appKey,
            responseId: responseId,
            startDate: startFact,
            endDate: endFact
        }
        let isAuthError = false;

        axios.post(apiUrl + '/app-stats/response-flow',
            options, { withCredentials: true })
            .then((res) => {
                if (res.data.status === 'ok') {
                    //clear errors 
                    if(errors?.length > 0) {
                        setErrors([])
                    }
                    if (res.data.prompts !== null) {
                        setPrompts(res.data.prompts);
                    }
                    if (res.data.app !== null) {
                        setApp(res.data.app);
                        document.title = `reconify response flow ${res.data.app.app}`;
                    }
                    if (res.data.response !== null) {
                        setResponse(res.data.response);
                    }
                } else {
                    if (res.data.hasOwnProperty('app') && res.data.app !== null) {
                        setApp(res.data.app);
                        document.title = `reconify response flow ${res.data.app.app}`;
                    }
                    if (res.data.response !== null) {
                        setResponse(res.data.response);
                    }
                    let errorMsgs = [];
                    let redirectToLogin = false;
                    res.data.errors.forEach((error, i) => {
                        switch (error) {
                            case 'auth-expired':
                            case 'auth-error':
                            case 'no-auth':
                            case 'no-valid-account':
                            case 'no-permissions':
                                //console.log('auth expired');
                                isAuthError = true;
                                redirectToLogin = true;
                                break;
                            case 'no-app':
                            case 'no-valid-app':
                                //console.log('no results')
                                errorMsgs.push('There was no matching app.');
                                break;
                            case 'no-response':
                                //console.log('no results')
                                errorMsgs.push('There was no matching response.');
                                break;
                            case 'no-results':
                                //console.log('no results')
                                errorMsgs.push('There were no matching prompts.');
                                break;
                            default:
                                //TODO: may want to just ignore - no sense showing anything?
                                errorMsgs.push('There was an error retrieving reports.');
                        }
                    });
                    //don't call setErrors if not logged in as it throws an unmounted error
                    if (redirectToLogin) {
                        navigate('/login');
                        return;
                    }
                    if (!isAuthError) {
                        setErrors(errorMsgs);
                    }
                }
            })
            .catch((err) => {

            });
    }, [accountKey, appKey, navigate, startFactDate, endFactDate])


    const sortByResponse = () => {
        //console.log('sorting prompt')
        let temp = [...prompts]
        temp.sort((a,b) => (a.prompt < b.prompt) ? -1 : 1)
        setPrompts(temp);
    }
    /*
    const sortByUsers = () => {
        //console.log('sorting prompt')
        let temp = [...prompts]
        temp.sort((a,b) => (a.users < b.users) ? 1 : -1)
        setPrompts(temp);
    }
    const sortBySessions = () => {
        //console.log('sorting prompt')
        let temp = [...prompts]
        temp.sort((a,b) => (a.sessions < b.sessions) ? 1 : -1)
        setPrompts(temp);
    }
    */
    const sortByInteractions = () => {
        //console.log('sorting prompt')
        let temp = [...prompts]
        temp.sort((a,b) => (a.interactions < b.interactions) ? 1 : -1)
        setPrompts(temp);
    }
    const sortByPrompts = () => {
        //console.log('sorting prompt')
        let temp = [...prompts]
        temp.sort((a,b) => (a.responses < b.responses) ? 1 : -1)
        setPrompts(temp);
    }
    const sortBySentiment = () => {
        //console.log('sorting prompt')
        let temp = [...prompts]
        temp.sort((a,b) => (a.sentiment < b.sentiment) ? 1 : -1)
        setPrompts(temp);
    }

    return (
        <Container fluid>
            <LeftNav isAppAnalytics={true} appKey={appKey} accountKey={accountKey} startFactDate={startFactDate} endFactDate={endFactDate} />
            <div>
                <h4>Prompts for response: {app !== null ? (<span className='report-subject'>{app.app}</span>) : null}</h4>
                {range != null ? (<div className='my-1'>{toDisplayDate(range.startDate)} - {toDisplayDate(range.endDate)}
                    <Button variant='link' size='sm' className='p-0 ms-2' onClick={() => setShowPicker(!showPicker)}><span className='config-btn'>&#x2699;</span></Button>
                </div>) : null}
                {showPicker ? (<DatePicker selected={startDatePicker} onChange={onDateChange}
                    startDate={startDatePicker} endDate={endDatePicker} selectsRange
                    minDate={alterDate(new Date(), -30)}
                    maxDate={new Date()} inline />) : (null)}

                <div className='d-flex justify-content-end'>{(response != null && (response.typeId == 1 || response.typeId == 4)) ? (
                    <>
                <Button className='btn-theme' size='md' href={`/account/${accountKey}/analytics/app/${appKey}/response/${responseId}${datesForLink}`}>see similar responses</Button> 
                </>
                ) : null}
                {(response != null && response.typeId == 1) ? (
                    <>
                <GuardrailBtn sampleId={responseId} typeId={2} classStyles='ms-3'/>
                </>
                ) : null}
                </div>
                
                {response != null ? (<div className='chat-bubble chat-bubble-in my-3'><PRContent text={response.response} typeId={response.typeId} filepath={response.filepath} size='md'/></div>) : null}
                {
                    errors.length > 0 ? (
                        <Alert variant='danger'>
                            {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
                        </Alert>
                    ) : (null)
                }
                {
                    prompts.length > 0 ? (
                        <>
                            
                            <Table borderless size='sm'>
                                <thead>
                                    <tr>
                                        <th><span onClick={sortByResponse} role="button">prompt</span></th>
                                        {/*<th className='text-end'><span onClick={sortByUsers} role="button">users</span></th>
                                        <th className='text-end'><span onClick={sortBySessions} role="button">sessions</span></th>*/}
                                        <th className='text-end'><span onClick={sortByInteractions} role="button">interactions</span></th>
                                        <th className='text-end'><span onClick={sortByPrompts} role="button">prompts</span></th>
                                        <th className='text-end'><span onClick={sortBySentiment} role="button">sentiment</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        prompts.map((prompt, i) => (
                                            <tr key={'prompt.' + i} >
                                                <td ><div className='chat-bubble mb-3'><PRContent text={prompt.prompt} typeId={prompt.typeId} filepath={prompt.filepath} size='md'/></div></td>
                                                {/*<td className='text-end'>{prompt.users}</td>                                                
                                                <td className='text-end'>{prompt.sessions}</td>*/}
                                                <td className='text-end'><Link to={`/account/${accountKey}/analytics/app/${appKey}/interactions${datesForLink}?promptId=${prompt.promptId}&responseId=${responseId}`}>{prompt.interactions}</Link></td>
                                                <td className='text-end'>{prompt.responses}</td>
                                                <td className='text-end' style={prompt.sentiment >= SENTIMENT_THRESHOLD ? { color: '#00b300' } : (prompt.sentiment < 0 ? { color: '#b30000' } : null)}>{roundNum(prompt.sentiment, 3)}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Table>
                        </>
                    ) : (
                        null
                    )
                }
            </div>
        </Container>
    )
}

export default ResponseFlow